import { CustomerDeliveryAddress } from "../../../../data/entities";

export const normalizeDeliveryAddress = (value: unknown): string =>
    typeof value === "string" ? value.trim() : "";

export const getDeliveryAddressValidationMessage = (value: unknown): string | null =>
    normalizeDeliveryAddress(value) ? null : "Vui lòng nhập địa chỉ giao hàng.";

export interface DeliveryAddressOption {
    text: string;
    value: string;
    label: string;
    description: string;
    key: string;
    badge?: string;
}

export const getDefaultDeliveryAddress = (
    addresses: CustomerDeliveryAddress[] = [],
): string => normalizeDeliveryAddress(addresses.find((item) => item.is_default === true)?.address);

export const buildDeliveryAddressOptions = (
    addresses: CustomerDeliveryAddress[] = [],
): DeliveryAddressOption[] =>
    addresses.map((item, index) => ({
        key: item.id || `address:${index}:${item.label}`,
        text: item.address,
        value: item.address,
        label: item.label,
        description: item.address,
        ...(item.is_default === true ? { badge: "Mặc định" } : {}),
    }));
